import { render, staticRenderFns } from "./SliModuleTabs.vue?vue&type=template&id=62105483&scoped=true"
import script from "./SliModuleTabs.vue?vue&type=script&lang=js"
export * from "./SliModuleTabs.vue?vue&type=script&lang=js"
import style0 from "./SliModuleTabs.vue?vue&type=style&index=0&id=62105483&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62105483",
  null
  
)

export default component.exports